<template>
  <h1>Providers</h1>
</template>
<script>
export default {
  name: "Providers"
}
</script>